// #region Imports
import React, { useEffect, useState } from 'react';
import useClientes from '../../hooks/useClientes';
import ClientesTable from '../../components/Clientes/ClientesTable/ClientesTable-Component';
import ClientesCrud from '../../components/Clientes/ClientesCrud/ClientesCrud-Component';
// #endregion

export default function ClientesPage() {
	// #region Hooks & serviços
	const { listar, obter, criar, atualizar, remover, clientes, computeStats, loading } = useClientes();
	// #endregion

	// #region Estado local (filtros, paginação, CRUD)
	const [q, setQ] = useState('');
	const [fSexo, setFSexo] = useState('TODOS');
	const [fSaldo, setFSaldo] = useState('TODOS');
	const [page, setPage] = useState(1);
	const [pageSize] = useState(10);
	const [listState, setListState] = useState({ data: [], total: 0 });
	const [editingId, setEditingId] = useState(null);
	const [crudOpen, setCrudOpen] = useState(false);
	// #endregion

	// #region Efeitos (carregar lista quando filtros mudam)
	useEffect(() => {
		const res = listar({ q, page, pageSize, sexo: fSexo, saldo: fSaldo });
		setListState(res);
	}, [listar, q, page, pageSize, fSexo, fSaldo]);
	// #endregion

	// #region Handlers filtros
	function handleFilterChange(next) {
		setQ(next.q);
		setFSexo(next.sexo);
		setFSaldo(next.saldo);
		setPage(1);
	}
	// #endregion

	// #region Derivados
	const stats = computeStats(clientes);
	const editingCliente = editingId ? obter(editingId) : null;
	// #endregion

	// #region Handlers CRUD
	function handleCreate() { setEditingId(null); setCrudOpen(true); }
	function handleEdit(id) { setEditingId(id); setCrudOpen(true); }
	function handleDelete(id) {
		remover(id);
		const res = listar({ q, page, pageSize });
		setListState(res);
	}
	function handleSave(payload) {
		if (editingId) atualizar(editingId, payload); else criar(payload);
		const res = listar({ q, page, pageSize });
		setListState(res);
	}
	// #endregion

	// #region Render
	return (
		<div className="clientes-page">
			<section>
				<ClientesTable
					loading={loading}
					stats={stats}
					filters={{ q, sexo: fSexo, saldo: fSaldo }}
					onFiltersChange={handleFilterChange}
					data={listState.data}
					total={listState.total}
					page={page}
					pageSize={pageSize}
					onPageChange={p => setPage(p)}
					onCreate={handleCreate}
					onEdit={handleEdit}
					onDelete={handleDelete}
				/>
			</section>
			<ClientesCrud
				open={crudOpen}
				cliente={editingCliente}
				onClose={() => setCrudOpen(false)}
				onSave={handleSave}
			/>
		</div>
	);
	// #endregion
}
